import React from 'react';
import ServiceUnderConstruction from '../../components/ServiceUnderConstruction';
import logo from '../../assets/images/services/kolabo.webp';

const KolaboTech = () => {
    return (
        <ServiceUnderConstruction
            serviceKey="kolabo"
            logo={logo}
            primaryColor="#9B59B6"
            secondaryColor="#8E44AD"
        />
    );
};

export default KolaboTech;
